<template>
  <div>
    <com-page>
      <com-card>
        <div>
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="0"></el-tab-pane>
            <el-tab-pane label="钱包" name="1"></el-tab-pane>
            <el-tab-pane label="小区列表" name="2"></el-tab-pane>
            <el-tab-pane label="设备列表" name="3"></el-tab-pane>
            <el-tab-pane label="充值订单" name="4"></el-tab-pane>
            <el-tab-pane label="充电订单" name="5"></el-tab-pane>
            <el-tab-pane label="套餐卡订单" name="6"></el-tab-pane>
          </el-tabs>
        </div>
      </com-card>
      <com-card class="mt-15px">
        <BasicInfo v-if="activeName === '0'" :detail="detail"></BasicInfo>

        <partner-wallet
          v-if="activeName === '1'"
          :level="detail.level"
          :code="detail.code"
        ></partner-wallet>

        <partner-community v-if="activeName === '2'" :level="detail.level" :code="detail.code"></partner-community>

        <partner-equ v-if="activeName === '3'" :level="detail.level" :code="detail.code"></partner-equ>

        <partner-recharge
          v-if="activeName === '4'"
          :level="detail.level"
          :code="detail.code"
        ></partner-recharge>

        <partner-order
          v-if="activeName === '5'"
          :level="detail.level"
          :code="detail.code"
        ></partner-order>

        <partner-package-order
          v-if="activeName === '6'"
          :level="detail.level"
          :code="detail.code"
        ></partner-package-order>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import PartnerSite from './components/partner-site'
import PartnerEqu from './components/partner-equ'
import PartnerOrder from './components/partner-order'
import PartnerIncome from './components/partner-income'
import PartnerWallet from './components/partner-wallet'
import PartnerRecharge from './components/partner-recharge'
import PartnerCommunity from './components/partner-community'
import PartnerPackageOrder from './components/partner-package-order'

import BasicInfo from './components/basic-info'

import { partnersDetailApi } from '@/api/partners'

export default {
  components: {
    PartnerSite,
    PartnerEqu,
    PartnerOrder,
    PartnerIncome,
    PartnerWallet,
    PartnerRecharge,

    BasicInfo,
    PartnerCommunity,
    PartnerPackageOrder
  },
  data() {
    return {
      activeName: '0',
      detail: {}
    }
  },

  created() {
    this.code = this.$route.query.code
    this.getDetail()
  },

  methods: {
    getDetail() {
      partnersDetailApi({code: this.code}).then((res) => {
        this.detail = res.data.partner
        console.log('详情--:>> ', this.detail.idPhotos)
        this.detail.idPhotos = JSON.parse(this.detail.idPhotos || '[]')
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
